import clsx from "clsx";
import { FC } from "react";
import s from "./styles.module.sass";

import NextLink from "@shared/wrappers/NextLink";

export interface ILink {
	id: number;
	title: string;
	to: string;
}

interface IBreadcrumbs {
	links: ILink[];
	currentPage: string;
	color?: "primary" | "secondary";
	className?: HTMLDivElement["className"];
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ links, currentPage, color, className }) => {
	const renderLinks = () => {
		return links.map((link) => {
			return (
				<div
					key={link.title}
					className={clsx(s.crumb, {
						[s.secondary]: color === "secondary",
					})}
				>
					<NextLink href={link.to} key={link.id}>
						{link.title}
					</NextLink>
					<div
						className={clsx(s.separator, {
							[s.secondary]: color === "secondary",
						})}
					/>
				</div>
			);
		});
	};

	return (
		<div className={clsx(s.breadcrumbs, className)}>
			{renderLinks()}
			<div className={s.currentPage}>{currentPage}</div>
		</div>
	);
};

export default Breadcrumbs;
